import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	updateDescriptionAndRetry: {
		id: 'ai-related-issues.find-similar-work-items.update-description-and-retry',
		defaultMessage: 'Update description and retry',
		description: 'Error message shown when there is a problem with the Atlassian Intelligence call',
	},
	noSimilarWorkItems: {
		id: 'ai-related-issues.find-similar-work-items.no-similar-work-items',
		defaultMessage: 'No similar work items',
		description: 'Message shown when no similar work items are found',
	},
	similarWorkItems: {
		id: 'ai-related-issues.find-similar-work-items.similar-work-items',
		defaultMessage: 'Similar work items',
		description: 'Title of the collapsible parent',
	},
});
